import React from 'react';
import { AppBar, Toolbar, Box, useTheme, useMediaQuery, Typography, IconButton, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import Logo from './Logo';
import ClubLogo from './ClubLogo';
import { useAuth } from '../context/AuthContext';

import SessionStatus from './SessionStatus';

interface HeaderProps {
  clubName?: string;
  clubId?: string;
  hasLogo?: boolean;
  userName?: string;
  showSessionStatus?: boolean;
}

const Header: React.FC<HeaderProps> = ({ clubName, clubId, hasLogo, userName, showSessionStatus = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { userRole, logout } = useAuth();
  
  // Bestimme die richtige Startseite basierend auf der Benutzerrolle
  const homePath = '/dashboard';

  return (
    <AppBar position="fixed" color="primary" elevation={1}>
      <Toolbar>
        {/* App Logo als Home-Button */}
        <Tooltip title="Dashboard">
          <Box 
            component={Link} 
            to={homePath}
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              textDecoration: 'none',
              color: 'inherit',
              mr: 2
            }}
          >
            <Logo height={isMobile ? 35 : 45} />
          </Box>
        </Tooltip>
        
        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          Meldeportal Trampolin
        </Typography>
        
        {/* ← NEU: Rechte Seite mit Session Status, Club Info und Logout */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

          {/* Club Logo and Name (if available) */}
          {clubName && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {hasLogo && clubId && (
                <ClubLogo 
                  clubId={clubId} 
                  hasLogo={hasLogo} 
                  size="small" 
                  withBorder={true} 
                />
              )}
              <Typography
                variant="body1"
                sx={{ 
                  color: 'white',
                  fontWeight: 500
                }}
              >
                {clubName}{userName ? ` (${userName})` : ''}
              </Typography>
            </Box>
          )}
          
          {/* Logout Button */}
          <Tooltip title="Logout">
            <IconButton color="inherit" onClick={logout}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
          
          {/* ← NEU: Session Status - immer anzeigen wenn User eingeloggt */}
          {showSessionStatus && userRole && (
            <SessionStatus 
              showInHeader={true} 
              compact={true} 
            />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;